import CaseFilter from '../statistics';
import CaseVolume from '../caseVolumeLineChart';
import CustomPieChart from '../customPieChart';
import CustomComponentAreaCaseBySubmission from '../customComponentAreaCaseBySubmission';
import GeographicalStatistics from '../geographicalStatistics';
import { FC } from 'react';
import { GeographicalStatisticsObject } from 'src/pages/manufacturer/types';
import AuthMaunfacturerSubHeader from '../authManufacturerSubHeader';
import { AllProductProps } from '../allProductsStats/types';
import DrillDownPieChart from '../drillDownPieChart';

const AllProductsFamRegion: FC<AllProductProps> = ({ statisticsData, queryParams, updateQueryParamsAndCallAPI, getStatisticsData, drug }): JSX.Element => {

  return (
    <div
      className={`container-fluid body-bg overflow-y-auto ${drug === "iovera" ? 'iovera-content' : drug === "ZILRETTA" ? 'zilretta-content' : ''}`} >
      <div className="container py-4">
        <AuthMaunfacturerSubHeader />
        {statisticsData && (
          <CaseFilter
            defaultQueryParams={queryParams}
            updateQueryParams={updateQueryParamsAndCallAPI}
            drug={drug}
          />
        )}
        {statisticsData && queryParams && (
          <CaseVolume startDate={queryParams.start_date} endDate={queryParams.end_date} StatisticsObjectType={statisticsData.data} getStatisticsData={getStatisticsData} buttonShows={false} drug={''} />
        )}
        <div>
          {statisticsData && <CustomPieChart pieChartObject={statisticsData.data.top_payors} title={'Top 10 Payors'} />}
        </div>
        <div >
          {statisticsData && statisticsData.data &&
            <CustomPieChart title="Top 10 Payor Types" pieChartObject={statisticsData.data.top_payer_types} />
          }
        </div>
        <div className='row'>
          <div className='col'>
            {statisticsData && statisticsData.data && statisticsData.data.icd_data &&
              <DrillDownPieChart pieChartObject={statisticsData.data.icd_data} title={'Top 10 ICD Codes'} />}
          </div>
        </div>
        {statisticsData && queryParams && (
          <CustomComponentAreaCaseBySubmission startDate={queryParams.start_date} endDate={queryParams.end_date} StatisticsObjectType={statisticsData.data} title={'Regions'} drug={''} />
        )}

        {statisticsData?.data && (
          <GeographicalStatistics
            GeographicalStatisticsListType={
              statisticsData?.data
                .geographical_stats as unknown as GeographicalStatisticsObject[]
            }
          />
        )}
      </div>
    </div>
  );
}
export default AllProductsFamRegion;